import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Box from '@mui/material/Box';

const BackButton = ({ pageName, url }) => {
  const navigate = useNavigate();

  const { batchId } = useParams();

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb">
        <Box
          color="inherit"
          onClick={() => {
            navigate(pageName.length ? url || -1 : '../batches/batch');
          }}
          sx={{
            '&:hover': {
              color: 'green',
              cursor: 'pointer',
            },
            my: 1.5,
          }}
          variant="text"
        >
          <Typography color="inherit" variant="caption">
            {pageName.length ? pageName : 'Batches'}
          </Typography>
        </Box>
        <Typography color="secondary.main" sx={{ pr: 8 }} variant="caption">
          Parent Batch #{batchId}
        </Typography>
      </Breadcrumbs>
    </div>
  );
};

BackButton.propTypes = {
  pageName: PropTypes.string,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

BackButton.defaultProps = {
  pageName: '',
  url: '',
};

export default BackButton;
